import { memo, useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { documentHotkeysSelector } from 'domain/documents/documentSelector';
import { journalSelector } from 'domain/journal';
import { hotkeyMatcher } from 'lib/hotkeysHelpers';
import { HotkeyMatchFactory } from 'domain/documents/factories';

const DocumentHotkeyCatcher = ({ handleHotkeyMatch }) => {
  const hotkeys = useSelector(documentHotkeysSelector);
  // for keyboard shortcuts it doesn't matter which cell passed to update field,
  // back-end skip update Field if hotkey Field is exist
  const plugCell = useSelector(journalSelector).first();

  const documentHotkeys = useMemo(() => hotkeys.filter((keys) => keys.level === 'document'), [hotkeys]);

  const onHotkeyMatch = useCallback(
    (keys) => {
      handleHotkeyMatch(plugCell.get('_cell'), null, false, HotkeyMatchFactory({ key: keys }));
    },
    [handleHotkeyMatch, plugCell],
  );

  const handleKeyDown = useCallback(
    (e) => {
      const isMatch = hotkeyMatcher(e, documentHotkeys, onHotkeyMatch);

      if (isMatch) {
        e.preventDefault();
      }
    },
    [documentHotkeys, onHotkeyMatch],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [documentHotkeys, handleKeyDown]);

  return null;
};

export default memo(DocumentHotkeyCatcher);
